/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PolitiqueConfidentialite = () => {
  useEffect(() => {
    document.title = 'Politique de confidentialité | Yellow Cab Corsica';
  }, []);

  return (
    <main className="bg-[#0A0A0A] min-h-screen pt-8 pb-28 md:pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-[#555] mb-10">
          <Link to="/" className="hover:text-[#A3A3A3] transition-colors">Accueil</Link>
          <span>/</span>
          <span className="text-[#A3A3A3]">Politique de confidentialité</span>
        </div>

        <h1
          className="text-3xl sm:text-4xl font-light text-white tracking-tight mb-10"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Politique de confidentialité
        </h1>

        <div className="space-y-8 text-[#A3A3A3]">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              1. Responsable du traitement
            </h2>
            <p className="text-sm leading-relaxed">
              <strong className="text-white">Dénomination commerciale :</strong> Taxis Yellow Cab Corsica<br />
              <strong className="text-white">Forme juridique :</strong> Entrepreneur individuel<br />
              <strong className="text-white">Siège social :</strong> Avenue du Maréchal Moncey, Bât. B6, Rés. Les Palmiers, 20090 Ajaccio, Corse-du-Sud<br />
              <strong className="text-white">SIREN :</strong> 888 339 272<br />
              <strong className="text-white">SIRET :</strong> 888 339 272 00013<br />
              <strong className="text-white">Email :</strong> <a href="mailto:taxiyellowcabcorsica@gmail.com" className="text-[#EAB308] hover:underline">taxiyellowcabcorsica@gmail.com</a><br />
              est responsable du traitement de vos données personnelles collectées via ce site.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              2. Données collectées
            </h2>
            <p className="text-sm leading-relaxed mb-3">
              Lorsque vous utilisez notre formulaire de réservation, nous collectons les données suivantes :
            </p>
            <ul className="text-sm space-y-1.5 list-disc list-inside">
              <li>Lieu de départ et lieu d'arrivée</li>
              <li>Date et heure du trajet</li>
              <li>Nombre de passagers</li>
              <li>Numéro de téléphone</li>
              <li>Adresse email</li>
              <li>Informations complémentaires (si renseignées)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              3. Finalités du traitement
            </h2>
            <p className="text-sm leading-relaxed">
              Les données collectées sont utilisées exclusivement pour :
            </p>
            <ul className="text-sm space-y-1.5 list-disc list-inside mt-2">
              <li>Traiter votre demande de réservation</li>
              <li>Vous contacter pour confirmer votre trajet</li>
              <li>Vous envoyer des informations relatives à votre réservation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              4. Base légale
            </h2>
            <p className="text-sm leading-relaxed">
              Le traitement de vos données est basé sur votre consentement (art. 6(1)(a) RGPD) lors de la soumission du formulaire de réservation, et sur l'exécution du contrat de transport (art. 6(1)(b) RGPD).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              5. Conservation des données
            </h2>
            <p className="text-sm leading-relaxed">
              Vos données personnelles sont conservées pour une durée maximale de 3 ans à compter de votre dernière interaction avec notre service, sauf obligation légale de conservation plus longue.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              6. Destinataires des données
            </h2>
            <p className="text-sm leading-relaxed">
              Vos données sont destinées exclusivement à l'équipe de Taxis Yellow Cab Corsica pour la gestion des réservations. Elles ne sont jamais vendues, louées ni transmises à des tiers à des fins commerciales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              7. Vos droits
            </h2>
            <p className="text-sm leading-relaxed">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="text-sm space-y-1.5 list-disc list-inside mt-2">
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement (droit à l'oubli)</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité des données</li>
              <li>Droit d'opposition</li>
            </ul>
            <p className="text-sm leading-relaxed mt-3">
              Pour exercer ces droits, contactez-nous à : <a href="mailto:taxiyellowcabcorsica@gmail.com" className="text-[#EAB308] hover:underline">taxiyellowcabcorsica@gmail.com</a>
            </p>
            <p className="text-sm leading-relaxed mt-2">
              Vous avez également le droit d'introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#EAB308] hover:underline">www.cnil.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              8. Cookies
            </h2>
            <p className="text-sm leading-relaxed">
              Ce site peut utiliser des cookies techniques nécessaires à son fonctionnement. Aucun cookie à des fins publicitaires ou de traçage commercial n'est utilisé sans votre consentement explicite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              9. Sécurité
            </h2>
            <p className="text-sm leading-relaxed">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              10. Modifications
            </h2>
            <p className="text-sm leading-relaxed">
              Nous nous réservons le droit de modifier la présente politique de confidentialité à tout moment. Les modifications entrent en vigueur dès leur publication sur ce site.
            </p>
            <p className="text-sm mt-2">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/8">
          <Link to="/" className="text-[#EAB308] text-sm hover:underline">
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PolitiqueConfidentialite;
